export const Title = {
  MAIN: 'Bezikaron Sales',
  PAYMENT_PAGE: 'Bezikaron Payments',
  SEARCH_INPUT_INVOICES: 'Search Invoice',
  SEARCH_INPUT_PAYMENTS: 'By invoice or purchaser phone',
};
